/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import Switcher = alm.state.Switcher;
	import SwitcherEvent = alm.state.SwitcherEvent;

	export class Map extends View<THREE.Object3D> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(new THREE.Object3D());

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Object3D {
			return this.getView();
		}

		protected implReady():void {
			const view:THREE.Object3D = this.getView();

			// terrain
			this.terrainTypeSwitcher = new Switcher<TerrainType>();
			let terrainTypes;
			if (Config.usePhotoTexture) {
				if (AssetLoader.getInstance().getPhotoTerrainTexture()) {
					terrainTypes = [
						TerrainType.Photo,
						TerrainType.SurfaceElevation,
						TerrainType.SurfaceGradient,
						TerrainType.Surface,
						TerrainType.WireFrame,
						//TerrainType.PointCloud,
						TerrainType.None,
					];
				} else {
					terrainTypes = [
						TerrainType.SurfaceElevation,
						TerrainType.SurfaceGradient,
						TerrainType.Surface,
						TerrainType.WireFrame,
						//TerrainType.PointCloud,
						TerrainType.None,
						TerrainType.Photo,
					];
				}
			} else {
				terrainTypes = [
					TerrainType.SurfaceElevation,
					TerrainType.SurfaceGradient,
					TerrainType.Surface,
					TerrainType.WireFrame,
					//TerrainType.PointCloud,
					TerrainType.None,
				];
			}
			this.terrainTypeSwitcher.setupById(terrainTypes);

			this.terrain = new Terrain();
			this.terrain.ready();
			view.add(this.terrain.getView());

			// activity
			this.landmarkLayer = new LandmarkLayer();
			this.landmarkLayer.ready();
			view.add(this.landmarkLayer.getView());

			//this.photoLayer = new PhotoLayer();
			//this.photoLayer.ready();
			//view.add(this.photoLayer.getView());

			// route
			this.route = new Route(this.terrain);
			this.route.ready();
			view.add(this.route.getView());

			const bounds = AssetLoader.getInstance().getMeta().getBounds();
			const boundsCenterPixel:THREE.Vector2 = bounds.getCenter().getPixel();
			const boundsSizeX:number = bounds.getPixelWidth();
			const boundsSizeZ:number = bounds.getPixelHeight();

			this.center = Unit.pixelToSpace(boundsCenterPixel, 0);

			// ground
			//this.ground = new Ground(boundsCenterPixel, boundsSizeX, boundsSizeZ);
			//this.ground.ready();
			//view.add(this.ground.getView());

			// bounding box
			this.boundingBox = new BoundingBox(boundsCenterPixel, boundsSizeX, boundsSizeZ);
			this.boundingBox.ready();
			view.add(this.boundingBox.getView());
		}

		protected implFinalize():void {
			this.terrain.finalize();
			//this.ground.finalize();
			this.boundingBox.finalize();
			this.landmarkLayer.finalize();
			//this.photoLayer.finalize();
			this.route.finalize();
		}

		protected implShow(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					this.terrain.show(useTransition);
					//this.ground.show(useTransition);
					this.boundingBox.show(useTransition);
					this.landmarkLayer.show(useTransition);
					//this.photoLayer.show(useTransition);
					this.route.show(useTransition);

					this.terrainTypeSwitcher.addEventListener(SwitcherEvent.CHANGE, this.terrainTypeSwitcherChangeHandler);
					this.terrainTypeSwitcher.gotoByIndex(0);
				})
			);
		}

		protected implHide(view:THREE.Object3D, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				new cmd.Func(():void => {
					if (!this.getIsInitializing()) {
						this.terrainTypeSwitcher.removeEventListener(SwitcherEvent.CHANGE, this.terrainTypeSwitcherChangeHandler);
						this.terrainTypeSwitcher.gotoById(null);

						this.terrain.hide(useTransition);
						//this.ground.hide(useTransition);
						this.boundingBox.hide(useTransition);
						this.landmarkLayer.hide(useTransition);
						//this.photoLayer.hide(useTransition);
						this.route.hide(useTransition);
					}
				})
			);
		}

		public update():void {
			if (!this.getIsShown()) return;

			this.terrain.update();
			this.route.update();
			this.landmarkLayer.update();
			//this.photoLayer.update();
		}

		public showEdge(useTransition:boolean = true):void {
			this.route.showEdge(useTransition);
		}

		public hideEdge(useTransition:boolean = true):void {
			this.route.hideEdge(useTransition);
		}

		public setHeadPosition(point:LeapedTrackPoint):void {
			this.route.setHeadPosition(point);
		}

		public setPrevTerrainType():void {
			trace('[Map] setPrevTerrainType');
			this.terrainTypeSwitcher.prev();
		}

		public setNextTerrainType():void {
			trace('[Map] setNextTerrainType');
			this.terrainTypeSwitcher.next();
		}

		private terrainTypeSwitcherChangeHandler = (event:SwitcherEvent<TerrainType>):void => {
			this.terrain.setTerrainType(event.oldItemId, event.newItemId);

			if (event.newItemId != TerrainType.None) {
				this.boundingBox.show();
			} else {
				this.boundingBox.hide();
			}
		};

		public getCurrentTrackPosition():THREE.Vector3 {
			return this.route.getHeadPosition();
		}

		public getCurrentTrackObject():THREE.Object3D {
			return this.route.getHeadObject();
		}

		public getMapCenter():THREE.Vector3 {
			return this.center;
		}

		public getMapY(x:number, z:number):number {
			return this.terrain.getY(x, z);
		}

		public getIntersection(raycaster:THREE.Raycaster):THREE.Intersection {
			return this.terrain.getIntersection(raycaster);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private center:THREE.Vector3;

		private terrain:Terrain;
		private terrainTypeSwitcher:Switcher;

		private route:Route;

		private landmarkLayer:LandmarkLayer;
		//private photoLayer:PhotoLayer;

		//private ground:Ground;
		private boundingBox:BoundingBox;
	}
}
